import Skeleton from "react-loading-skeleton";

const loadingSwitch = (screenNO) => {
  switch (screenNO) {
    case 1:
      return (
        // <Skeleton
        //   //   containerClassName="w-100 "
        //   duration={4}
        //   count={3}
        //   width={200}
        //   height={40}
        //   baseColor="#000"
        <> LOADING </>
        // />
      );
    case 2:
      return <Skeleton count={6} />;
    case 3:
      return <Skeleton count={9} />;
    case 4:
      return <Skeleton count={12} />;
    default:
      return <Skeleton count={5} />;
  }
};
const Loading = (screenNO = 0) => {
  return (
    <div className=" d-flex justify-content-center m-auto align-items-center col-9">
      {loadingSwitch(screenNO)}
    </div>
  );
};

export default Loading;
